import "./PlannogrammTackStyle.scss"
import "./PlanogrammTasckSliderStyle.scss"
import React, {useEffect, useState, useRef, useCallback} from 'react';
import ButtonBack from "../../../components/Buttons/buttonBack/ButtonBack";
import ButtonHint from "../../../components/Buttons/buttonHint/ButtonHint";
import {HandySvg} from "handy-svg";
import MediaPicker from "../../../utils/js/mediaPicer/MediaPicker";

import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Thumbs, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/thumbs';
import 'swiper/css/navigation';

import tg from "./img/tg.svg"
import closeSVG from "../../Hint/HintContainer/AddImg/img/close-X.svg";

import {
    decodeTokens,
    FetchElements,
    GetCookie,
    Request,
    updateRefreshToken,
    useButtonLock,
} from "../../../utils/js/request";

import {PLANNOGRAMM, MEDIA, GET_ROLE, USER_LOGIN} from "../../../utils/js/Const";
import {useLocation, useNavigate} from "react-router-dom";
import PLannogrammTaskSlider from "./PLannogrammTaskSlider";

import "../../../utils/js/UtilsJs"
import {AddBodyModifikator, RemoveBodyModifikator} from "../../../utils/js/UtilsJs";
import {TransformComponent, TransformWrapper, useControls} from "react-zoom-pan-pinch";
import PlannogrammAddTasck from "../PlannogrammAddTasck/PlannogrammAddTasck";
import CustomAlert from "../../../components/CustomAlert/CustomAlert";
import useFileUploader from "../../../utils/js/PhotoUploader";
import {useSetStatIsExist} from "../../../utils/hooks/useSetStatIsExist/useSetStatIsExist";

function PlannogrammTack ( {props} ) {

    const { setStatIsExist } = useSetStatIsExist();

    const [uploadedPhotoIds, setUploadedPhotoIds] = useState([]);

    const handleUploadComplete = useCallback((fileId, serverId) => {
        setUploadedPhotoIds(prev => {
            const newIds = [...prev, serverId];
            return newIds;
        });
    }, []);

    const {
        files: uploadedPhotos,
        progress,
        statuses,
        addFiles,
        removeFile: deletePhoto,
        retryUpload,
        isUploading,
        hasPendingUploads,
        initializeExistingFiles,
        resetUploaderState,
    } = useFileUploader({
        compress: true,
        onUploadComplete: handleUploadComplete,
        onUploadError: (fileId, error) => {
            console.error(`Ошибка загрузки файла ${fileId}:`, error);
            handleOpenAlert("Ошибка", `${error}`, "")
        },
        onUploadRejected: async (fileId, reason) => {
            handleOpenAlert(
                'Уведомление',
                'Эту фотографию вы уже ранее загружали',
                ''
            );
            try {
                await setStatIsExist();
                console.log('✅ setStatIsExist выполнен');
            } catch (error) {
                console.error('❌ Ошибка setStatIsExist:', error);
            }
        },
    });

    let role = GET_ROLE();
    let userNameLocal = USER_LOGIN();

    let periodDays = [
        {id:1,name: "Каждый день", value: 1},
        {id:7,name: "Раз в неделю", value: 7},
        {id:14,name: "Раз в две недели", value: 14},
        {id:30,name: "Раз в месяц", value: 30},
        {id:90, name: "Раз в в три месяца", value: 90},
    ]

    let duringDays = [
        {id:3,name: "В течение трех дней", value: 3},
        {id:7,name: "В течение недели", value: 7},
        {id:14,name: "В течении двух недель", value: 14},
        {id:30,name: "В течении месяца", value: 30},
        {id:60,name: "В течении двух месяцев", value: 60},
        {id:90,name: "В течении трех месяцев", value: 90},
        {id:180,name: "В течении полугода", value: 180},
    ]

    function returnGvPeriodValue(mass, fetchValue) {
        const foundItem = mass.find(item => item.value === fetchValue);
        return foundItem ? foundItem.name : "Не указано";
    }

    const chatEndRef = useRef(null);
    let navigate = useNavigate();
    let location = useLocation();
    let {state} = location;

    const guid = window.location.pathname.split('/').pop();
    // Самый безопасный способ получить taskId
    const taskId = (state && state.target_guid !== null && state.target_guid !== undefined)
        ? state.target_guid
        : guid;

    const [accessToken, setAccessToken] = useState(GetCookie("access_token"));

    useEffect(() => {
        const fetchData = async () => {
            if (!accessToken) {
                const newToken = await updateRefreshToken(setAccessToken, null, () => {
                    navigate("/")
                });
                if (newToken) {
                    decodeTokens();
                }
            } else {
                decodeTokens();
            }
        };
        fetchData();
    }, [accessToken]);

    //Универсальный блокиратор отправки повторных запросов
    const { isDisabled, lockButton, unlockButton } = useButtonLock();

    const [getTaskData, setGetTaskData] = useState([]);
    const [chat, setChat] = useState([]);
    const [textareaValue, setTextareatValue] = useState("");

    //Стейты проегресса


    // Стейты со стилем для фото которые долго загружаются
    const [longloading, setLongloading] = useState({})

    const [photos, setPhotos] = useState([]);
    const [isScrollable, setIsScrollable] = useState(false);

    const containerRef = useRef(null);

    /*Редактирование*/
    const [isEditing, setIsEditing] = useState(false);

    const [isOpenAlert, setIsOpenAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertTitle, setAlertTitle] = useState('');
    const [alertStatusCod, setAlertStatusCod] = useState('')

    // Существующие состояния
    const [SrcBigImg, setSrcBigImg] = useState(null);
    const [isFullscreenChat, setIsFullscreenChat] = useState(false);
    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    const thumbsSwiperRef = useRef(null);
    const [currentChatImageIndex, setCurrentChatImageIndex] = useState(0);
    const [currentChatImages, setCurrentChatImages] = useState([]);
    const transformChatRef = useRef(null);

    /*Для фоток без сохранения*/
    const [cameraPhotoDataUrl, setCameraPhotoDataUrl] = useState(null);
    const handleCapture = (photoDataUrl) => {
        setCameraPhotoDataUrl(photoDataUrl);
        if (photoDataUrl) {
            // Создаем Blob из Data URL
            const blob = dataURLtoBlob(photoDataUrl);
            // Создаем File из Blob
            const file = new File([blob], "camera_photo.png", { type: "image/png" });
            // Добавляем File в состояние files с помощью addFiles
            addFiles([file]);
        }
    };

    /*Открытие больших фоток*/
    const [isFullscreen, setIsFullscreen] = useState(false);

    function OpenFullSizeChat(photo, messageIndex, photoIndex) {
        // Собираем все изображения из всех сообщений чата
        const allChatImages = [];
        chat.forEach((message, msgIdx) => {
            message.attachments.forEach((attachment, attIdx) => {
                allChatImages.push({
                    img: attachment,
                    messageIndex: msgIdx,
                    photoIndex: attIdx
                });
            });
        });

        // Находим индекс текущего изображения
        const currentIndex = allChatImages.findIndex(img =>
            img.messageIndex === messageIndex && img.photoIndex === photoIndex
        );

        setCurrentChatImages(allChatImages);
        setCurrentChatImageIndex(currentIndex);
        setIsFullscreenChat(true);
        AddBodyModifikator();
    }

    function CloseFullSizeChat() {
        setIsFullscreenChat(false);
        RemoveBodyModifikator();
    }

    const goToNextChatImage = () => {
        if (currentChatImages.length > 0) {
            const newIndex = currentChatImageIndex === currentChatImages.length - 1 ? 0 : currentChatImageIndex + 1;
            setCurrentChatImageIndex(newIndex);
            // Синхронизируем миниатюры с основным изображением
            if (thumbsSwiper && thumbsSwiper.slideTo) {
                thumbsSwiper.slideTo(newIndex);
            }
            setTimeout(() => {
                if (transformChatRef.current) {
                    transformChatRef.current.resetTransform();
                }
            }, 50);
        }
    };

    const goToPrevChatImage = () => {
        if (currentChatImages.length > 0) {
            const newIndex = currentChatImageIndex === 0 ? currentChatImages.length - 1 : currentChatImageIndex - 1;
            setCurrentChatImageIndex(newIndex);
            // Синхронизируем миниатюры с основным изображением
            if (thumbsSwiper && thumbsSwiper.slideTo) {
                thumbsSwiper.slideTo(newIndex);
            }
            setTimeout(() => {
                if (transformChatRef.current) {
                    transformChatRef.current.resetTransform();
                }
            }, 50);
        }
    };

    const goToNextThumb = () => {
        if (thumbsSwiperRef.current) {
            thumbsSwiperRef.current.swiper.slideNext();
        }
    };

    const goToPrevThumb = () => {
        if (thumbsSwiperRef.current) {
            thumbsSwiperRef.current.swiper.slidePrev();
        }
    };

    const handleKeyDown = (e) => {
        if (!isFullscreen && !isFullscreenChat) return;

        switch(e.key) {
            case 'ArrowLeft':
                e.preventDefault();
                if (isFullscreenChat) {
                    goToPrevChatImage();
                }
                break;
            case 'ArrowRight':
                e.preventDefault();
                if (isFullscreenChat) {
                    goToNextChatImage();
                }
                break;
            case 'Escape':
                e.preventDefault();
                if (isFullscreenChat) {
                    CloseFullSizeChat();
                } else if (isFullscreen) {
                    CloseFullSize();
                }
                break;
            default:
                break;
        }
    };

    const handleThumbClick = (index) => {
        setCurrentChatImageIndex(index);
        if (thumbsSwiper && thumbsSwiper.slideTo) {
            thumbsSwiper.slideTo(index);
        }
        setTimeout(() => {
            if (transformChatRef.current) {
                transformChatRef.current.resetTransform();
            }
        }, 50);
    };

    React.useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [isFullscreen, isFullscreenChat, currentChatImageIndex, isFullscreen]);


    const dataURLtoBlob = (dataurl) => {
        const arr = dataurl.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], { type: mime });
    };

    const handleOpenAlert = (title, message, statusCod) => {
        setAlertTitle(title);
        setAlertMessage(message);
        setAlertStatusCod(statusCod);
        setIsOpenAlert(true);
    };

    const handleCloseAlert = () => {
        setIsOpenAlert(false);
    };


    function CloseFullSize() {
        setSrcBigImg(null);
        RemoveBodyModifikator();
    }

    const handleScroll = () => {
        if (containerRef.current) {
            // Проверяем, есть ли прокрутка
            if (containerRef.current.scrollHeight > containerRef.current.clientHeight) {
                setIsScrollable(true);
            } else {
                setIsScrollable(false);
            }
        }
    };

    useEffect(() => {
        const container = containerRef.current;
        if (container) {
            container.addEventListener('scroll', handleScroll);
            handleScroll();

            return () => {
                container.removeEventListener('scroll', handleScroll);
            };
        }
    }, [chat]);

    function formatDateForInput(dateString) {
        if (!dateString) {
            return ""
        }else{
            const date = new Date(dateString);

            // Получаем компоненты даты
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Месяцы начинаются с 0
            const day = String(date.getDate()).padStart(2, '0');

            // Форматируем дату в нужный формат
            return `${day}-${month}-${year}`;
        }
    }

    const Controls = () => {
        const {zoomIn, zoomOut, resetTransform} = useControls();

        return (
            <div className="tools">
                <div className="imageContainer--close" style={{alignItems: "center"}} onClick={() => zoomIn()}>+</div>
                <div className="imageContainer--close" onClick={() => zoomOut()}>-</div>
                <div className="imageContainer--close" onClick={() => resetTransform()}>⊡</div>
                <div className="imageContainer--close" style={{transform: "rotate(44deg)"}} onClick={CloseFullSize}>+</div>
            </div>
        );
    };

    const handleChange = (event) => {
        setTextareatValue(event.target.value);
    };

    let imageUrls = getTaskData.attachments ? getTaskData.attachments.map(id => ({
        img: `${id}`,
    })) : [];

    useEffect(() => {
        FetchElements(`${PLANNOGRAMM}/api/v1/tasks/${taskId}`,"GET", setGetTaskData, navigate,2,() => navigate("/"),handleOpenAlert);
    }, []);

    useEffect(() => {
        FetchElements(`${PLANNOGRAMM}/api/v1/chats/${taskId}`, "GET", setChat, navigate,2,() => navigate("/"),handleOpenAlert);
    }, []);

    const scrollToBottom = () => {
        const chatContainer = document.querySelector('.chat');
        if (!chatContainer) return;

        // Ждём следующего фрейма анимации
        requestAnimationFrame(() => {
            chatContainer.scrollTop = chatContainer.scrollHeight;
        });
    };

    useEffect(() => {
        const timer = setTimeout(scrollToBottom, 300); // Ждём загрузки изображений
        return () => clearTimeout(timer);
    }, [chat]);

    async function sendMessage() {

        if (hasPendingUploads) {
            handleOpenAlert("Ошибка", "Загрузка файлов еще не завершена. Пожалуйста, дождитесь окончания.", "");
            return;
        }

        if (isDisabled === true) {
            handleOpenAlert("Ошибка", "Дождитесь окончания отправки сообщения", "");
            return;
        }

        updateRefreshToken(setAccessToken, null);

        let objToSend = {
            "message": textareaValue.trim(),
            "attachments": uploadedPhotoIds,
        };

        let data = JSON.stringify(objToSend);
        let responseStatusCode

        lockButton();

        try {
            const response = await fetch(`${PLANNOGRAMM}/api/v1/chats/${taskId}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "access-token": `${accessToken}`,
                },
                body: data,
            });

            const result = await response.json();
            responseStatusCode = response.status;
            if (!response.ok) {
                handleOpenAlert('Ошибка', `${result.message}`, `${response.status}`);
                return;
            }

            let newMessage = {
                message: result.data.message,
                user: {
                    login: result.data.user.login,
                    fio: result.data.user.fio,
                },
                attachments: result.data.attachments || [],
            };

            handleOpenAlert("Уведомление", `${result.message}`, `${response.status}`);
            setChat(prevChat => [...prevChat, newMessage]);
            setTextareatValue("");
            addFiles([]);
            setUploadedPhotoIds([]);
            setPhotos([]);
            setLongloading([]);
            resetUploaderState();
        } catch (error) {
            handleOpenAlert("Ошибка", error.message, responseStatusCode);
        } finally {
            unlockButton();
        }
    }

    const handleFileChange = e => {
        const files = Array.from(e.target.files);
        if (files.length > 0) {
            addFiles(files);
        }
    };

    const handleDelete = (id) => {
        const photo = uploadedPhotos.find(p => p.id === id);
        if (!photo) return;

        // Обновляем uploadedPhotoIds только если файл был успешно загружен на сервер
        if (photo.status === 'completed' && photo.serverId) {
            setUploadedPhotoIds(prev => prev.filter(pid => pid !== photo.serverId));
        }
        deletePhoto(id);
    };

    function return_massage_position (login, user){
        if (userNameLocal === login){
            return ("sent");
        }else if (userNameLocal === user){
            return ("sent");
        }else {
            return("received");
        }
    }

    function return_massage_color (login, user){
        if (userNameLocal === login){
            return ("myMassage");
        }else if (userNameLocal === user){
            return ("myMassage");
        }else {
            return("notMyMassage");
        }
    }

    function chatReturn() {
        if (chat.length !== 0) {
            return (
                <div className={`chat_wrapper ${ChatsMobile}`}>
                    <div className="chat">
                        <div className="chat_message_wrapper">
                            {chat.map((data, index) => (
                                <div className={`chat_massage ${return_massage_position(data.user.login, data.user)}`} key={index}>
                                    <div className={"chat_message_header"}>
                                        <div className={`chat_message_name`}>{data.user.fio}</div>
                                        <div className={`chat_message_name`}>{data.datetime_create}</div>
                                    </div>
                                    <div className={`chat_message_conteiner ${return_massage_color(data.user.login, data.user)}`}>
                                        <div className="chat_message">{data.message}</div>
                                        <div className="chat_photo_wrapper">
                                            {data.attachments.map((photo, photoIndex) => (
                                                <img
                                                    key={photoIndex}
                                                    className="chat_img"
                                                    loading="lazy"
                                                    src={`${MEDIA}/api/attachments/${photo}`}
                                                    onClick={() => { OpenFullSizeChat(photo, index, photoIndex) }} // Правильный вызов
                                                    alt={`Attachment ${photoIndex}`}
                                                />
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            ))}
                            <div ref={chatEndRef}/>
                        </div>
                    </div>
                    <div className="chat_wrapper_send" style={{display: rolePlay(role)}}>
                        <div className="chat_container_send">
                        <textarea
                            placeholder="Сообщение..."
                            className="chat_message_textarea mobile_chats_ogranichenia"
                            value={textareaValue}
                            onChange={handleChange}
                        />
                            <div className="chat_wrapper_send_buttons">
                                <MediaPicker
                                    onFilesSelected={addFiles}
                                    onCameraCapture={handleCapture}
                                />
                                {
                                    isDisabled ? (
                                        <div className="loader"></div>
                                    ) : (
                                        <button className="send_message" onClick={sendMessage} disabled={isDisabled}>
                                            <HandySvg src={tg} className="addImgIcon2" />
                                        </button>
                                    )
                                }
                            </div>
                        </div>
                        <div
                            className="chat_wrapper_send_photo_gallery"
                            style={{display: uploadedPhotos.length === 0 ? 'none' : ''}}
                        >
                            {uploadedPhotos.map(photo => {
                                const status = statuses[photo.id] || 'pending';
                                const currentProgress = progress[photo.id] || 0;
                                const previewUrl = photo.previewUrl || `${MEDIA}/api/attachments/${photo.serverId}`;


                                return (
                                    <div className="img_wrapper" key={photo.id} id={photo.id}>
                                        <HandySvg
                                            src={closeSVG}
                                            className="close_img"
                                            onClick={() => handleDelete(photo.id)}
                                        />
                                        <div
                                            className={`wrapper__file-upload addImg chat_wrapper_send_photo_gallery_img ${status === 'pending' ? "AwaitingDownload" : ""}`}
                                            style={{
                                                backgroundImage: `url(${previewUrl})`,
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "cover",
                                                padding: "0",
                                            }}
                                        >
                                            {status === 'pending' && (
                                                <div className="wrapper__file-upload__diteils wrapper__file-upload__diteils__modificator">
                                                    <div>Ожидает</div>
                                                </div>
                                            )}

                                            {status === 'uploading' && (
                                                <div className="wrapper__file-upload__diteils wrapper__file-upload__diteils__modificator">
                                                    <div>Загрузка {currentProgress}%</div>
                                                </div>
                                            )}

                                            {status === 'error' && (
                                                <div className="wrapper__file-upload__diteils wrapper__file-upload__diteils__modificator LongLoadingTime">
                                                    <div>Ошибка</div>
                                                    <button
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            retryUpload(photo.id);
                                                        }}
                                                        className="retry-button"
                                                    >
                                                        Повторить
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div className={`chat_wrapper ${ChatsMobile}`}>
                    <div className="chat" style={{display: "flex",alignItems: "center",justifyContent:"center"}}>
                        <div className="chat_message_wrapper">
                            <div className="chat_wrapper_none_Massage">
                                <div className="chat_noneMassage">
                                    Сейчас сообщений нет...
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="chat_wrapper_send" style={{display: rolePlay(role)}}>
                        <div className="chat_container_send">
                        <textarea
                            placeholder="Сообщение..."
                            className="chat_message_textarea mobile_chats_ogranichenia"
                            value={textareaValue}
                            onChange={handleChange}
                        />
                            <div className="chat_wrapper_send_buttons">
                                <MediaPicker
                                    onFilesSelected={addFiles}
                                    onCameraCapture={handleCapture}
                                />
                                {
                                    isDisabled ? (
                                        <div className="loader"></div>
                                    ) : (
                                        <button className="send_message" onClick={sendMessage} disabled={isDisabled}>
                                            <HandySvg src={tg} className="addImgIcon2" />
                                        </button>
                                    )
                                }
                            </div>
                        </div>
                        <div
                            className="chat_wrapper_send_photo_gallery"
                            style={{display: uploadedPhotos.length === 0 ? 'none' : ''}}
                        >
                            {uploadedPhotos.map(photo => {
                                const status = statuses[photo.id] || 'pending';
                                const currentProgress = progress[photo.id] || 0;
                                const previewUrl = photo.previewUrl || `${MEDIA}/api/attachments/${photo.serverId}`;


                                return (
                                    <div className="img_wrapper" key={photo.id} id={photo.id}>
                                        <HandySvg
                                            src={closeSVG}
                                            className="close_img"
                                            onClick={() => handleDelete(photo.id)}
                                        />
                                        <div
                                            className={`wrapper__file-upload addImg chat_wrapper_send_photo_gallery_img ${status === 'pending' ? "AwaitingDownload" : ""}`}
                                            style={{
                                                backgroundImage: `url(${previewUrl})`,
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "cover",
                                                padding: "0",
                                            }}
                                        >
                                            {status === 'pending' && (
                                                <div className="wrapper__file-upload__diteils wrapper__file-upload__diteils__modificator">
                                                    <div>Ожидает</div>
                                                </div>
                                            )}

                                            {status === 'uploading' && (
                                                <div className="wrapper__file-upload__diteils wrapper__file-upload__diteils__modificator">
                                                    <div>Загрузка {currentProgress}%</div>
                                                </div>
                                            )}

                                            {status === 'error' && (
                                                <div className="wrapper__file-upload__diteils wrapper__file-upload__diteils__modificator LongLoadingTime">
                                                    <div>Ошибка</div>
                                                    <button
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            retryUpload(photo.id);
                                                        }}
                                                        className="retry-button"
                                                    >
                                                        Повторить
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            );
        }
    }

    function chatReturnMobile() {
        if (chat.length !== 0) {
            return (
                <div className={`chat_wrapper ${ChatsMobile}`}>
                    <div className="chat">
                        <div className="chat_message_wrapper">
                            {chat.map((data, index) => (
                                <div className={`chat_massage ${return_massage_position(data.user.login, data.user)}`} key={index}>
                                    <div className={"chat_message_header"}>
                                        <div className={`chat_message_name`}>{data.user.fio}</div>
                                        <div className={`chat_message_name`}>{data.datetime_create}</div>
                                    </div>
                                    <div className={`chat_message_conteiner ${return_massage_color(data.user.login, data.user)}`}>
                                        <div className="chat_message">{data.message}</div>
                                        <div className="chat_photo_wrapper">
                                            {data.attachments.map((photo, photoIndex) => (
                                                <img
                                                    key={photoIndex}
                                                    className="chat_img"
                                                    loading="lazy"
                                                    src={`${MEDIA}/api/attachments/${photo}`}
                                                    onClick={() => { OpenFullSizeChat(photo, index, photoIndex) }} // Правильный вызов
                                                    alt={`Attachment ${photoIndex}`}
                                                />
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            ))}
                            <div ref={chatEndRef}/>
                        </div>
                    </div>
                    <div className="chat_wrapper_send" style={{display: rolePlay(role)}}>
                        <div
                            className="chat_wrapper_send_photo_gallery"
                            style={{display: uploadedPhotos.length === 0 ? 'none' : ''}}
                        >
                            {uploadedPhotos.map(photo => {
                                const status = statuses[photo.id] || 'pending';
                                const currentProgress = progress[photo.id] || 0;
                                const previewUrl = photo.previewUrl || `${MEDIA}/api/attachments/${photo.serverId}`;


                                return (
                                    <div className="img_wrapper" key={photo.id} id={photo.id}>
                                        <HandySvg
                                            src={closeSVG}
                                            className="close_img"
                                            onClick={() => handleDelete(photo.id)}
                                        />
                                        <div
                                            className={`wrapper__file-upload addImg chat_wrapper_send_photo_gallery_img ${status === 'pending' ? "AwaitingDownload" : ""}`}
                                            style={{
                                                backgroundImage: `url(${previewUrl})`,
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "cover",
                                                padding: "0",
                                            }}
                                        >
                                            {status === 'pending' && (
                                                <div className="wrapper__file-upload__diteils wrapper__file-upload__diteils__modificator">
                                                    <div>Ожидает</div>
                                                </div>
                                            )}

                                            {status === 'uploading' && (
                                                <div className="wrapper__file-upload__diteils wrapper__file-upload__diteils__modificator">
                                                    <div>Загрузка {currentProgress}%</div>
                                                </div>
                                            )}

                                            {status === 'error' && (
                                                <div className="wrapper__file-upload__diteils wrapper__file-upload__diteils__modificator LongLoadingTime">
                                                    <div>Ошибка</div>
                                                    <button
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            retryUpload(photo.id);
                                                        }}
                                                        className="retry-button"
                                                    >
                                                        Повторить
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                        <div className="chat_container_send">
                        <textarea
                            placeholder="Сообщение..."
                            className="chat_message_textarea mobile_chats_ogranichenia"
                            value={textareaValue}
                            onChange={handleChange}
                        />
                            <div className="chat_wrapper_send_buttons">
                                <MediaPicker
                                    onFilesSelected={addFiles}
                                    onCameraCapture={handleCapture}
                                />
                                {
                                    isDisabled ? (
                                        <div className="loader"></div>
                                    ) : (
                                        <button className="send_message" onClick={sendMessage} disabled={isDisabled}>
                                            <HandySvg src={tg} className="addImgIcon2" />
                                        </button>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div className={`chat_wrapper ${ChatsMobile}`}>
                    <div className="chat" style={{display: "flex",alignItems: "center",justifyContent:"center"}}>
                        <div className="chat_message_wrapper">
                            <div className="chat_wrapper_none_Massage">
                                <div className="chat_noneMassage">
                                    Сейчас сообщений нет...
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="chat_wrapper_send" style={{display: rolePlay(role)}}>
                        <div className="chat_container_send">
                        <textarea
                            placeholder="Сообщение..."
                            className="chat_message_textarea mobile_chats_ogranichenia"
                            value={textareaValue}
                            onChange={handleChange}
                        />
                            <div className="chat_wrapper_send_buttons">
                                <MediaPicker
                                    onFilesSelected={addFiles}
                                    onCameraCapture={handleCapture}
                                />
                                {
                                    isDisabled ? (
                                        <div className="loader"></div>
                                    ) : (
                                        <button className="send_message" onClick={sendMessage} disabled={isDisabled}>
                                            <HandySvg src={tg} className="addImgIcon2" />
                                        </button>
                                    )
                                }
                            </div>
                        </div>
                        <div
                            className="chat_wrapper_send_photo_gallery"
                            style={{display: uploadedPhotos.length === 0 ? 'none' : ''}}
                        >
                            {uploadedPhotos.map(photo => {
                                const status = statuses[photo.id] || 'pending';
                                const currentProgress = progress[photo.id] || 0;
                                const previewUrl = photo.previewUrl || `${MEDIA}/api/attachments/${photo.serverId}`;


                                return (
                                    <div className="img_wrapper" key={photo.id} id={photo.id}>
                                        <HandySvg
                                            src={closeSVG}
                                            className="close_img"
                                            onClick={() => handleDelete(photo.id)}
                                        />
                                        <div
                                            className={`wrapper__file-upload addImg chat_wrapper_send_photo_gallery_img ${status === 'pending' ? "AwaitingDownload" : ""}`}
                                            style={{
                                                backgroundImage: `url(${previewUrl})`,
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "cover",
                                                padding: "0",
                                            }}
                                        >
                                            {status === 'pending' && (
                                                <div className="wrapper__file-upload__diteils wrapper__file-upload__diteils__modificator">
                                                    <div>Ожидает</div>
                                                </div>
                                            )}

                                            {status === 'uploading' && (
                                                <div className="wrapper__file-upload__diteils wrapper__file-upload__diteils__modificator">
                                                    <div>Загрузка {currentProgress}%</div>
                                                </div>
                                            )}

                                            {status === 'error' && (
                                                <div className="wrapper__file-upload__diteils wrapper__file-upload__diteils__modificator LongLoadingTime">
                                                    <div>Ошибка</div>
                                                    <button
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            retryUpload(photo.id);
                                                        }}
                                                        className="retry-button"
                                                    >
                                                        Повторить
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            );
        }
    }

    function updateTaskStatus_2() {

        const objToSend = {
            "target_guid": [taskId],
            "status_id": 2,
        };

        const data = JSON.stringify(objToSend);

        fetch(`${PLANNOGRAMM}/api/v1/status/tasks`, {
            method: "PATCH",
            headers: {
                "Accept": "application/json",
                "Access-Token": accessToken,
                "Content-Type": "application/json",
            },
            body: data,
        })
            .then(response => {
                if (!response.ok) {
                    return response.json().then(errorData => {
                        throw new Error(`${errorData.message}, код: ${response.status}`);
                    });
                }
                return response.json();
            })
            .then(result => {
                handleOpenAlert('Уведомление', `${result.message || "Статус задачи успешно обновлён!"}`, `${result.status || ""}`);
            })
            .catch(error => {
                handleOpenAlert('Ошибка', `${error.message ||"Ошибка при обновлении статуса задачи"}`);
            });
    }
    function updateTaskStatus_3() {

        const objToSend = {
            "target_guid": [taskId], // Используем состояние task_guid
            "status_id": 3,
        };

        const data = JSON.stringify(objToSend);

        fetch(`${PLANNOGRAMM}/api/v1/status/tasks`, {
            method: "PATCH",
            headers: {
                "Accept": "application/json",
                "Access-Token": accessToken,
                "Content-Type": "application/json",
            },
            body: data,
        })
            .then(response => {
                if (!response.ok) {
                    return response.json().then(errorData => {
                        throw new Error(`${errorData.message}, код: ${response.status}`);
                    });
                }
                return response.json();
            })
            .then(result => {
                handleOpenAlert('Уведомление', `${result.message || "Статус задачи успешно обновлён!"}`, `${result.status || ""}`);
            })
            .catch(error => {
                handleOpenAlert('Ошибка', `${error.message ||"Ошибка при обновлении статуса задачи"}`);
            });
    }
    function updateTaskStatus_4() {

        const objToSend = {
            "target_guid": [taskId], // Используем состояние task_guid
            "status_id": 4,
        };

        const data = JSON.stringify(objToSend);

        fetch(`${PLANNOGRAMM}/api/v1/status/tasks`, {
            method: "PATCH",
            headers: {
                "Accept": "application/json",
                "Access-Token": accessToken,
                "Content-Type": "application/json",
            },
            body: data,
        })
            .then(response => {
                if (!response.ok) {
                    return response.json().then(errorData => {
                        throw new Error(`${errorData.message}, код: ${response.status}`);
                    });
                }
                return response.json();
            })
            .then(result => {
                handleOpenAlert('Уведомление', `${result.message || "Статус задачи успешно обновлён!"}`, `${result.status || ""}`);
            })
            .catch(error => {
                handleOpenAlert('Ошибка', `${error.message ||"Ошибка при обновлении статуса задачи"}`);
            });
    }
    function updateTaskStatus_5() {
        setIsEditing(true); // Открываем компонент редактирования
    }

    const closeEditing = () => {
        setIsEditing(false); // Закрываем компонент редактирования
    };

    function return_butt (){
        if (role === "Планограмщик" || role === "Технолог ГВ" || role === "Главный технолог ГВ"){
            return (
                <>
                    { (getTaskData.status_name==="Выполнена")?
                        <div></div>:
                        <ButtonHint text={"Редактировать задачу"} className={"send_to_revision"} funck={updateTaskStatus_5} style={{display: rolePlay(role)}}/>
                    }
                    <div className={"but_plan"}>
                        <ButtonHint text={"Отправить на доработку"} className={"close_task"} funck={updateTaskStatus_2} style={{display: rolePlay(role)}}/>
                        <ButtonHint text={"Закрыть задачу"} className={"send_to_complited"} funck={updateTaskStatus_4} style={{display: rolePlay(role)}}/>
                    </div>
                </>
            )
        }else if (role === "Админ"){
            return (
                <>
                    <ButtonHint text={"Отправить на проверку"} className={"send_to_complited"} funck={updateTaskStatus_3} style={{display: rolePlay(role)}}/>
                    <ButtonHint text={"Отправить на доработку"} className={"close_task"} funck={updateTaskStatus_2} style={{display: rolePlay(role)}}/>
                    <ButtonHint text={"Закрыть задачу"} className={"send_to_complited"} funck={updateTaskStatus_4} style={{display: rolePlay(role)}}/>
                    { (getTaskData.status_name==="Выполнена")?
                        <div></div>:
                        <ButtonHint text={"Редактировать задачу"} className={"send_to_revision"} funck={updateTaskStatus_5} style={{display: rolePlay(role)}}/>
                    }
                </>
            )
        } else if (role !== "Обычный Планограмщик") {
            if (!getTaskData?.status) return null;
            if (getTaskData.status.id === 3 || getTaskData.status.id === 4) {
                return null;
            } else {
                return (
                    <ButtonHint
                        text="Отправить на проверку"
                        className="send_to_complited"
                        funck={updateTaskStatus_3}
                        style={{ display: rolePlay(role) }}
                    />
                );
            }
        }
    }

    const [isOpen, setIsOpen] = useState(false);
    const [ChatsMobile, setChatsMobile] = useState("")
    const [ChatsDesctop, setChatsDesctop] = useState("")

    const handleClick = () => {
        setIsOpen(!isOpen);
        if (isOpen === false){
            setChatsMobile("ChatDopClass");
            setChatsDesctop("ChatDopClass2");
        }else{
            setChatsMobile("")
            setChatsDesctop("")
        }
    };

    useEffect(() => {
        if (!isOpen) return;

        const timer = setTimeout(() => {
            if (chatEndRef.current) {
                chatEndRef.current.scrollIntoView({ behavior: "smooth" });
            }
        }, 300);

        return () => clearTimeout(timer);
    }, [chat, isOpen]); // Добавляем isOpen в зависимости

    const [scale, setScale] = useState(100);

    const handleWheel = (event) => {
        event.preventDefault();

        if (event.deltaY > 0) {
            setScale((prevScale) => Math.max(prevScale - 5, 20));
        } else {
            setScale((prevScale) => prevScale + 5);
        }
    };

    function rolePlay (role){
        if (role === "Обычный Планограмщик"){
            return ("none")
        }else{
            return ("flex")
        }
    }


    return (
        <>
            {!isEditing && (
                <div>
                    {isFullscreenChat && currentChatImages.length > 0 && (
                        <div className="fullscreen-container">
                            <div className="fullscreen-image-wrapper">
                                {/* Большие стрелки - управляют ОСНОВНЫМ слайдером */}
                                <button className="control-button nav-button-side nav-button-prev" onClick={goToPrevChatImage}>
                                    ᐸ
                                </button>

                                <TransformWrapper
                                    ref={transformChatRef}
                                    initialScale={1}
                                    minScale={0.1}
                                    maxScale={20}
                                    centerOnInit={true}
                                    limitToBounds={false}
                                    panning={{ velocityDisabled: false, lockAxisX: false, lockAxisY: false }}
                                    doubleClick={{ disabled: false }}
                                    key={currentChatImageIndex}
                                >
                                    <TransformComponent>
                                        <img
                                            className="fullscreen-image"
                                            src={`${MEDIA}/api/attachments/${currentChatImages[currentChatImageIndex].img}`}
                                            alt={`Изображение чата ${currentChatImageIndex + 1}`}
                                        />
                                    </TransformComponent>
                                </TransformWrapper>

                                <button className="control-button nav-button-side nav-button-next" onClick={goToNextChatImage}>
                                    ᐳ
                                </button>
                            </div>

                            <div className="bottom-controls-panel">
                                <div className="controls-row navigation-row">
                                    <button
                                        className="thumbs-nav-button thumbs-prev"
                                        onClick={goToPrevThumb}
                                    >
                                        ᐸ
                                    </button>

                                    <div className="thumbs-container">
                                        <Swiper
                                            ref={thumbsSwiperRef}
                                            modules={[FreeMode, Thumbs, Navigation]}
                                            watchSlidesProgress={true}
                                            freeMode={true}
                                            spaceBetween={8}
                                            slidesPerView="auto"
                                            centeredSlides={false}
                                            centerInsufficientSlides={false}
                                            slidesOffsetBefore={0}
                                            slidesOffsetAfter={0}
                                            navigation={{
                                                nextEl: '.thumbs-next',
                                                prevEl: '.thumbs-prev',
                                            }}
                                            className="thumbs-swiper"
                                            onSwiper={setThumbsSwiper}
                                        >
                                            {currentChatImages.map((item, index) => (
                                                <SwiperSlide key={index} style={{ width: 'auto' }}>
                                                    <img
                                                        src={`${MEDIA}/api/attachments/${item.img}`}
                                                        alt={`Миниатюра ${index + 1}`}
                                                        className={`thumb-image ${index === currentChatImageIndex ? 'active' : ''}`}
                                                        onClick={() => handleThumbClick(index)}
                                                    />
                                                </SwiperSlide>
                                            ))}
                                        </Swiper>
                                    </div>

                                    <button
                                        className="thumbs-nav-button thumbs-next"
                                        onClick={goToNextThumb}
                                    >
                                        ᐳ
                                    </button>
                                </div>

                                <div className="controls-row zoom-row">
                                    <div className="zoom-controls">
                                        <button className="control-button zoom-button" onClick={() => {
                                            if (transformChatRef.current) {
                                                transformChatRef.current.zoomOut();
                                            }
                                        }} title="Уменьшить">
                                            -
                                        </button>
                                        <button className="control-button zoom-button" onClick={() => {
                                            if (transformChatRef.current) {
                                                transformChatRef.current.resetTransform();
                                            }
                                        }} title="Сбросить масштаб">
                                            ⊡
                                        </button>
                                        <button className="control-button zoom-button" onClick={() => {
                                            if (transformChatRef.current) {
                                                transformChatRef.current.zoomIn();
                                            }
                                        }} title="Увеличить">
                                            +
                                        </button>
                                    </div>
                                    <button className="control-button close-button" onClick={CloseFullSizeChat} title="Закрыть">
                                        ×
                                    </button>
                                </div>
                            </div>

                            <div className="image-counter">
                                {currentChatImageIndex + 1} / {currentChatImages.length}
                            </div>
                        </div>
                    )}

                    <div>
                        <ButtonBack/>
                        <CustomAlert
                            title={alertTitle}
                            message={alertMessage}
                            statusCod={alertStatusCod}
                            isOpenAlert={isOpenAlert}
                            onClose={handleCloseAlert}
                        />
                        <div className="max--width--control" id="plannogramm_wrapper_task" key={getTaskData.guid}>
                            <div className="plannogramm_wrapper_task_wrapper">
                                <div>
                                    <span className="plannogramm_wrapper_task_title">Название:</span>
                                    <span>{getTaskData?.name}</span>
                                </div>
                                <div>
                                    <span className="plannogramm_wrapper_task_title">Статус:</span>
                                    <span>{getTaskData?.status?.name}</span>
                                </div>
                            </div>
                            <div className="plannogramm_wrapper_task_wrapper">
                                <div>
                                    <span className="plannogramm_wrapper_task_title">Магазин:</span>
                                    <span>{state?.shop_name}</span>
                                </div>
                                <div>
                                    <span className="plannogramm_wrapper_task_title">Приоритет:</span>
                                    <span>{getTaskData?.priority?.name}</span>
                                </div>
                            </div>
                            <div className="plannogramm_wrapper_task_wrapper">
                                <div>
                                    <span className="plannogramm_wrapper_task_title">Частота создания:</span>
                                    <span>{returnGvPeriodValue(periodDays, getTaskData.period_days)}</span>
                                </div>
                            </div>
                            <div className="plannogramm_wrapper_task_wrapper dateTimeMobile_wrapper">
                                <div className="dateTimeMobile">
                                    <span className="plannogramm_wrapper_task_title">Дата начала:</span>
                                    <span>{formatDateForInput(getTaskData.datetime_begin)}</span>
                                </div>
                                <div className="dateTimeMobile">
                                    <span className="plannogramm_wrapper_task_title">Дата окончания:</span>
                                    <span>{formatDateForInput(getTaskData.datetime_end)}</span>
                                </div>
                            </div>
                            <div className="plannogramm_wrapper_task_wrapper description">
                                <span className="plannogramm_wrapper_task_title">Описание:</span>
                                <span  className="plannogramm_wrapper_task_comment">{getTaskData?.about}</span>
                            </div>
                            <div className="plannogramm_wrapper_task_wrapper">
                                <div className="plannogramm_wrapper_task_conteiner">
                                    <div>
                                    <span
                                        className="plannogramm_wrapper_task_title">Для закрытия задачи нужен фотоотчет:</span>
                                        <span>{
                                            getTaskData.for_close_need_photo ? "Да" : "Нет"
                                        }</span>
                                    </div>
                                    <div>
                                        <span className="plannogramm_wrapper_task_title">Комментарий:</span>
                                        <span className="plannogramm_wrapper_task_comment">{getTaskData?.comment || "Нет"}</span>
                                    </div>
                                </div>
                                <div className="plannogramm_wrapper_task_conteiner swippers_container">
                                <span
                                    className="plannogramm_wrapper_task_title commentSlider">Пример выполнения задачи:</span>
                                    <div className="Slider">
                                        <PLannogrammTaskSlider img={imageUrls}/>
                                    </div>
                                </div>
                            </div>
                            <div className={`plannogramm_wrapper_chat ${ChatsDesctop}`}>
                                <span className="plannogramm_wrapper_task_title chat_decktom">Чат:</span>
                                {
                                    chatReturn()
                                }
                            </div>
                            <div className="ButchatMobile" onClick={handleClick}>
                                перейти в чат
                            </div>
                            <div className={`ChatMobile ${isOpen ? 'visible' : ''}`}>
                                <div className="ChatMobile_hellp_wrapper">
                                    <div className="ButchatMobileExit" onClick={handleClick}>×</div>
                                    {
                                        chatReturnMobile()
                                    }
                                </div>
                            </div>
                            {
                                return_butt()
                            }
                        </div>
                    </div>
                </div>
            )}
            {isEditing && (
                <PlannogrammAddTasck
                    onClose={closeEditing}
                    dataTasck={getTaskData}
                />
            )}
        </>
    );
}

export default PlannogrammTack;